<template>
	<div>
		<el-dialog :title="form.title" :visible.sync="formOpen" :width="!$store.state.isphone?'800px':($store.state.width-12+'px')" :before-close="formClose">
			<div v-loading="$store.state.formload">
				<el-form :model="EAform" :rules="EArules" ref="EAform" :label-width="!$store.state.isphone?'110px':''">
					<el-form-item label="名称" prop="name">
						<el-input v-model="EAform.name" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="分组设备" prop="terminalIdAll" v-if="form.title=='添加'">
						<my-packet v-model="EAform.terminalIdAll" placeholder="请选择设备"></my-packet>
					</el-form-item>
					<el-form-item label="图片" prop="image">
						<my-upload v-model="EAform.image"></my-upload>
					</el-form-item>
					<el-form-item label="地址" prop="address">
						<my-cascader v-model="EAform.address" :placeholder="form.title=='添加'?'请选择地址':'未修改'"></my-cascader>
					</el-form-item>
					<el-form-item label="描述" prop="description">
						<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="EAform.description"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button :size="$store.state.isphone?'mini':'medium'" @click="formOpen = false">取 消</el-button>
					<el-button :size="$store.state.isphone?'mini':'medium'" type="primary" @click="save()">{{form.Bname}}</el-button>
				</div>
			</div>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>分组管理</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row class="top">
			<el-col :span="24">
				<el-button type="primary" :size="$store.state.isphone?'small':''" icon="el-icon-circle-plus-outline" @click="Add()">添加分组</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-row v-if="data.length>0" class="card-w">
					<el-col :span="24">
						<el-card shadow="hover" :body-style="{ padding: '0px' }" class="bg-purple" v-for="(item, key) in data" :key="key">
							<div>
								<div class="card2">
									<div class="card3">
										<span class="zi1">{{item.name}}</span>
										<el-popover
										  placement="bottom"
										  width="60"
										  trigger="hover">
											<div>
												<el-button type="primary" size="mini" @click="Edit(item)" class="sm-btn1">编辑</el-button>
												<el-button style="float: right;" type="danger" size="mini" @click="Delete(item)">删除</el-button>
											</div>
											<el-button slot="reference" class="zi2" icon="el-icon-edit" type="text"></el-button>
										</el-popover>
									</div>
								</div>
								<div @click="moveto(item)" style="cursor: pointer;">
									<el-row class="ljs-body">
										<el-col :span="10" class="ljs-beijing">
											<img  :src="config['apiurl'] + item.image">
										</el-col>
										<el-col :span="9" :offset="1" class="dis-inbl">
											<p>传感器数：</p>
											<p>控制器数：</p>
											<p>数据条数：</p>
										</el-col>
										<el-col :span="4" class="tex-ri">
											<p class="ljs-zi2" :title="item.terminalDevicesInfo.sensorCount">{{ item.terminalDevicesInfo.sensorCount }}</p>
											<p class="ljs-zi2" :title="item.terminalDevicesInfo.finalCount">{{ item.terminalDevicesInfo.finalCount }}</p>
											<p class="ljs-zi2" :title="item.terminalDevicesInfo.devicesDataCount">{{ convert(item.terminalDevicesInfo.devicesDataCount) }}</p>
										</el-col>
										<el-col :span="24">
											<p class="ljs-diqu" :title="item.address">{{item.address}}</p>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
				<el-row v-else>
					<el-col :span="24">
						<div class="none">
							<span>暂无数据 ！</span>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [],
				formOpen: false,
				form: {
					title: "添加",
					Bname: "添 加"
				},
				EAform: {
					id: "",
					qaedasId: "",
					terminalIdAll: "",
					name: "",
					address: "",
					image: "",
					description: ""
				},
				EArules: {
					terminalIdAll: [
						{ required: true, message: '请选择设备', trigger: 'blur' }
					],
					name: [
						{ required: true, message: '请输入名称', trigger: 'blur' }
					],
					address: [
						{ required: true, message: '请选择地址', trigger: 'blur' }
					],
					image: [
						{ required: true, message: '请上传图片', trigger: 'blur' }
					]
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad (node, resolve) {
						let val=node.path;
						_this.loadadr(val)
						.then((adr) => {
							resolve(adr);
						});
					}
				}
			};
		},
		methods: {
			save()
			{
				this.$refs['EAform'].validate((valid) => {
					if (valid) {
						this.$store.commit('formload',true);
						if(this.form.title=="编辑")
						{
							this.api.Packet.update(this.EAform)
							.then((response)=>{
								if(response.data.code==1)
								{
									this.formOpen=false;
									this.load();
								}
								this.$store.commit('formload',false);
							});
						}
						else
						{
							this.api.Packet.add(this.EAform)
							.then((response)=>{
								if(response.data.code==1)
								{
									this.formOpen=false;
									this.load();
								}
								this.$store.commit('formload',false);
							});
						}
					}
				});
			},
			Edit(item)
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.form.title="编辑";
					this.form.Bname="编 辑";
					this.setdata(this.EAform,item);
					this.EAform.address=item.city;
				});
			},
			Add()
			{
				this.formOpen=true;
				this.$nextTick(()=>{
					this.$refs['EAform'].resetFields();
					this.form.title="添加";
					this.form.Bname="添 加";
				});
			},
			Delete(item)
			{
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					this.api.Packet.delete({id: item.id})
					.then(() => {
						this.load();
					});
				});
			},
			moveto(item)
			{
				this.$router.push({ path: '/iot/PacketData',query: { id: item.id,name:item.name } });
			},
			load()
			{
				this.getPacket();
			},
			convert(num)
			{
				var mynum=0;
				if(num>10000)
				{
					mynum=num/10000;
					return mynum.toFixed(1)+"万";
				}
				else
				{
					return num;
				}
			},
			getPacket()
			{
				this.$store.commit('mainload',true);
				this.api.Packet.getList()
				.then((response)=>{
					if(response.data.code==1)
					{
						this.data=response.data.data.list;
						this.$store.commit('mainload',false);
					}
				})
			}
		},
		mounted: function () {
			this.load();
		},
		beforeDestroy: function () {
			
		}
	}
</script>

<style scoped>
	p{
		margin: 0;
	}
	.el-upload {
		display: inline-block;
		text-align: center;
		cursor: pointer;
		outline: 0;
		border: 1px grey dashed !important;
		border-radius: 5% !important;
	}
	.ljs-diqu {
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		border-top:1px solid rgb(91,155,213) ;
		padding: 4px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.ljs-zi2{
		font-size:15px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.dis-inbl {
		line-height: 28px;
		text-align: right;
		position: relative;
		top: 10px;
	}
	.tex-ri {
		line-height: 28px;
		text-align: left;
		position: relative;
		top: 10px;
	}
	.ljs-body{
		height:117px;
		padding: 6px 0px 6px 6px;
	}
	.ljs-beijing{
		text-align: center;
	}
	.ljs-beijing img {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}
	.bg-purple{
		/* background: #d3dce6; */
		width:240px;
		/* border-radius: 4px;
		min-height: 36px;
		height: 180px;
		margin-right: 20px;
		margin-bottom: 20px;
		border: 1px solid #d3dce6;
		background-color: white; */
		margin-top: 10px; 
		float: left;
		margin-right: 10px;
	}
	.dibu {
		margin-bottom: 1rem;
	}
	
	.neirong {
		margin-bottom: 20px;
		text-align: left;
	}
	
	.tup1 {
		width: 8rem;
		height: 8rem;
		margin: auto;
	}
	
	.zi2 {
		float: right;
		padding: 3px 0;
		color: #555;
		margin-right: 0.9375rem;
	}
	
	.zi1 {
		color: #555;
	}
	
	.card3 {
		padding-top: 6px;
	}
	
	.card2 {
		background-color: #9faec5;
		height: 2rem;
		/* border-bottom: 0.0625rem solid #EBEEF5; */
		text-align: center;
		/* border-radius: 4px 4px 0 0; */
	}
	
	.card1 {
		width: 16rem;
		text-align: center;
		margin-top: 1.25rem;
		float: left;
		margin-left: 1.25rem;
	}
	
	.kuan {
		width: 100%;
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	.border{
		border: 1px solid #dcdfe6;
		border-radius:4px;
	}
	.padding{
		padding-top: 16px;
	}
	.title{
		text-align: center;
		margin-top: -10px;
	}
	.top{
		margin-top: 10px;
	}
	.none{
		margin-top: 80px;
		margin-bottom: 80px;
		text-align: center;
		font-size: 80px;
		font-family: "STCaiyun";
		color: #1991FA;
	}
	.lixian{
		float: right; 
		color: gray; 
		margin-right: 0.9375rem;
	}
	.zaixian{
		float: right; 
		color: green; 
		margin-right: 0.9375rem;
	}
	.dialog-footer{
		text-align: center;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.content{
		display: flex;
		margin-top: 10px;
	}
	.content-item{
		width: 100%;
		margin: 5px;
		background-color: #9faec5;
		color: white;
		text-align: center;
		padding: 3px;
		border-radius: 5px;
	}
	.content-content{
		font-size: 18px;
		margin-top: 10px;
	}
	.content-title{
		font-size: 12px;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bg-purple{
			width: 100%;
			float: none;
		}
		.bread{
			padding-left: 5px;
		}
		.top{
			margin-left: 5px;
		}
		.card-w{
			padding: 0 5px;
			padding-top: 5px;
		}
	}
</style>
